const STORAGE_KEY = 'anon_user_token';

// Not guaranteed to be unique
const generateString = (length: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789=+/_-';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
};

export default () => {
  if (theme.customer) {
    return theme.customer.id.toString();
  }

  let anonToken = localStorage.getItem(STORAGE_KEY);

  if (!anonToken) {
    anonToken = generateString(16);
    localStorage.setItem(STORAGE_KEY, anonToken);
  }

  return `anon-${anonToken}`;
};
